import React from 'react';
import i18n from '../../locales/index';
import { Col, Row, Image } from 'react-bootstrap'
import './index.css'
import TitleLight from '../../components/Text/TitleLight';
import MainStyles from '../../styles/MainStyles';
import BadgeIcon from '../BadgeIcon';
import { convertDate, formatNumber } from '../../services/utils'

const ServiceCard = ({
    vehicleServicingDate ,
    vehicleServicingMileage,
    workDescription,
    vehicleServicingType,
    hasBorder,
    vehicleServicingActiveStamp,
    labelCompletedService,
    isFreeReview,
    orderService
}) => {

    return (
      <Col className={`card-container ${hasBorder ? 'middle-col' : ''}`} md={6} lg={4} xl={4} sm={6} xs={12} style={{marginBottom: '64px'}}>
        <BadgeIcon
          isFreeReview={isFreeReview}
          orderService={orderService}
          isValid={vehicleServicingActiveStamp}
          vehicleServicingType={vehicleServicingType}/>
        <Row>
          <Col style={{marginTop:"20px"}}>
            <TitleLight
              text={workDescription}
              color={MainStyles.colors.black}
              ownClass={'service_history_text'}
              size={'bigger'} />
            <p className='service_history_margin'>
              <TitleLight
                text={formatNumber(vehicleServicingMileage)}
                color={MainStyles.colors.black}
                size={'medium'} />
              <TitleLight
                text={i18n.t('general.km')}
                color={MainStyles.colors.black}
                size={'small'} />
            </p>
            <p className='service_history_margin'>
              <span className={`${vehicleServicingActiveStamp ? 'circle-green' : 'circle-red'}`}></span>
              <TitleLight
                text={labelCompletedService}
                color={MainStyles.colors.black}
                size={'small'} />
              <TitleLight
                text={convertDate(vehicleServicingDate, true)}
                color={MainStyles.colors.black}
                size={'small'} />
            </p>
          </Col>
        </Row>

      </Col>
    )
}

export default ServiceCard
